  
    import { Component, Mixins, Ref } from "vue-property-decorator";
    import ETable from "@/components/ETable.vue";
    import RichText from "@/components/rich-text.vue";
  
    import TablePagination from "@/mixins/tablePagination";
    import Resize from "@/mixins/resize";

    import { tongueShareConfig, getPhysiqueNameList } from "@/api/tongue";
    import { ElForm } from "element-ui/types/form";

    import { formatTextarea } from "@/utils/common";

    import PulseAssociationDialog from "./pulseAssociationDialog.vue";

    import { cloneDeep } from "lodash";
    import { getPulseList } from "@/api/consultation"
  
    @Component({
      components: {
        ETable,
        RichText, PulseAssociationDialog
      }
    })
    export default class Corporeity extends Mixins(Resize, TablePagination) {
      @Ref("formRef") formRef !: ElForm;

      tableData: Array<any> = [];
      tableLoading = false;
      columns = [
        { label: "序号", prop: "id" },
        { label: "体质名称", prop: "symptomName" },
        { label: "关联体质辨识", minWidth: "110", prop: "physiqueName" },
        { label: "舌色", prop: "tongueColor" },
        { label: "苔色", prop: "mossColor" },
        { label: "舌形", prop: "tongueShaped" },
        { label: "苔质", prop: "coatingNature" },
        { label: "舌下络脉", prop: "sublingualCollaterals" },
        { label: "形体特征", minWidth: "180", prop: "physicalCharacteristics" },
        { label: "形体特征代表人物（男）", minWidth: "180", prop: "roleOfMan"},
        { label: "形体特征代表人物（女）", minWidth: "180", prop: "roleOfWoman"},
        { label: "心理特征", minWidth: "180", prop: "psychology"},
        { label: "心理特征代表人物（男）", minWidth: "180",prop: "mentalityOfMan"},
        { label: "心理特征代表人物（女）", minWidth: "180", prop: "mentalityOfWoman"},
        { label: "湿气程度%", minWidth: "100", prop: "congestionLevel"},
        { label: "瘀堵程度%", minWidth: "100", prop: "moistureLevel"},
        { label: "操作", width: "100", prop: "action", "fixed": "right"},
    ]

      activeName = "first";

      // physiqueNameOptions = [
      //   { id: 1, name: "特禀" },
      //   { id: 2, name: "痰湿" },
      //   { id: 3, name: "湿热" },
      //   { id: 4, name: "气虚" },
      //   { id: 5, name: "阴虚" },
      //   { id: 6, name: "阳虚" },
      //   { id: 7, name: "血瘀" },
      //   { id: 8, name: "气郁" },
      //   { id: 9, name: "平和" },
      // ];

      physiqueNameOptions = [];

      tongueColorOptions = [
        { id: 1, name: "青紫舌" },
        { id: 2, name: "绛红舌" },
        { id: 3, name: "红舌" },
        { id: 4, name: "淡红舌" },
        { id: 5, name: "淡白舌" },
      ];

      tongueShareOptions = [
        { id: 1, name: "灰黑苔" },
        { id: 2, name: "黄苔" },
        { id: 3, name: "白苔" },
        { id: 4, name: "无苔" },
      ]

      tongueShapedOptions = [
        { id: 1, name: "光滑舌" },
        { id: 2, name: "娇嫩舌" },
        { id: 3, name: "苍老舌" },
        { id: 4, name: "裂纹舌" },
        { id: 5, name: "瘦薄舌" },
        { id: 6, name: "舌尖点刺" },
        { id: 7, name: "舌边点刺" },
        { id: 8, name: "齿痕舌" },
        { id: 9, name: "胖大舌" }
      ];

      tongueFurQualityOptions = [
        { id: 1, name: "厚腻苔" },
        { id: 2, name: "滑苔" },
        { id: 3, name: "薄苔" }
      ]

      queryForm = {
        physiqueName: "",
        coatingNature: "",
        mossColour: "",
        tongueColour: "",
        tongueShaped: "",
      }

      pulseDialogVisible = false;
      editData = {
        id: "",
        symptomName: "",
        physiqueName: ""
      };

      pulseOptions = [];
  
      mounted() {
        this.windowResize(220);
        this.getData();
        this.getPhysiqueNameOptions();
      }

      getPhysiqueNameOptions() {
        getPhysiqueNameList({physiqueNameType: 0}).then((res) => {
          this.physiqueNameOptions = res.data;
        });
      }

      formatTextarea(content) {
        return formatTextarea(content)
      }

      handleSearch() {
        this.resetCurrent();
        this.getData();
      }
  
      getData() {
        const params = {
          ...this.queryForm,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        };
        tongueShareConfig(params).then((res) => {
          this.tableData = res.data.list;
          this.itemTotal = res.data.total;
        })
        getPulseList({keyword:""}).then((res) => {
          this.pulseOptions = res.data;
        })
      }

      pulseAssociation(row) {
        this.editData = cloneDeep(row);
        this.pulseDialogVisible = true;
      }
  
    }
  